function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import { LocaleContext } from "../../../../context";
import React from 'react';
import { Cell } from "./cell/Cell";
import { HeaderRow, HeaderWrapper } from "./Header.styles";
export var Header = function Header(_ref) {
  var columns = _ref.columns,
      onSort = _ref.onSort,
      sorting = _ref.sorting;
  return React.createElement(HeaderWrapper, {
    className: "header__wrapper"
  }, React.createElement(LocaleContext.Consumer, null, function (intl) {
    return React.createElement(HeaderRow, {
      className: "header__row"
    }, columns.map(function (column) {
      return React.createElement(Cell, {
        className: "header__cell header__cell--".concat(column.key),
        id: column.key,
        key: column.key,
        text: column.name && _typeof(column.name) === 'object' ? intl.formatMessage(column.name) : column.name,
        style: column.headerStyle,
        sortable: !!column.comparator,
        sorting: sorting,
        onSort: onSort
      });
    }));
  }));
};